<template>
  <div class="relative right-0 h-content-window overflow-hidden">
    <div class="w-full h-full bg-white overflow-auto p-2">
      <div class="w-full h-full">
        <iframe
          :src="pdfPath"
          class="w-full h-full border-0"
          style="min-height: 600px;"
          title="PDF Viewer"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useLocaleStore } from '@/stores/localeStore'

const localeStore = useLocaleStore()

// Chemin vers le PDF (peut être ajusté selon le fichier)
const pdfPath = computed(() => {
  // Utiliser mon-cv.pdf s'il existe, sinon utiliser un CV existant selon la langue
  // Vous pouvez remplacer par '/pdf/mon-cv.pdf' si vous ajoutez ce fichier
  return '/pdf/mon-cv.pdf'
  // Alternative: utiliser un CV existant selon la langue
  // return `/pdf/CV_paul_jaguin_${localeStore.currentLocale}.pdf`
})
</script>

